module.exports = __webpack_public_path__ + "static/img/lv4.90833aa.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pcImg/other/lv4.png
// module id = iXJz
// module chunks = 1